import globals from "@lvt/globals";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";


export default applyCaseMiddleware(
    axios.create({
        baseURL: globals.userdashboard.proxyUrl,
        withCredentials: true,
    }),
    {
        preservedKeys: [
            "controlMode",
            "controlValue",
            "controlXValue",
            "controlYValue",
            "resolutionX",
            "resolutionY",
        ],
    },
);
